export const AUSTRALIAN_CITIZEN_AU_CITIZEN = 'AU_CITIZEN';
export const AUSTRALIAN_CITIZEN_AU_PERMANENT = 'AU_PERMANENT_CITIZEN';
export const AUSTRALIAN_CITIZEN_NZ_CITIZEN = 'NZ_CITIZEN';
export const OTHER_CITIZEN_WORK_VISA = 'WORK_VISA';
export const OTHER_CITIZEN_TRAVEL_VISA = 'TRAVEL_VISA';
export const OTHER_CITIZEN_STUDENT_VISA = 'STUDENT_VISA';
export const OTHER_CITIZEN_SPONSORSHIP_VISA = 'SPONSORSHIP_VISA';

export const australianOceanicCitizen = [
  { title: 'family.field.residency.au.citizen', type: AUSTRALIAN_CITIZEN_AU_CITIZEN, intl: true },
  { title: 'family.field.residency.au.permanent.resident', type: AUSTRALIAN_CITIZEN_AU_PERMANENT, intl: true },
  { title: 'family.field.residency.nz.citizen', type: AUSTRALIAN_CITIZEN_NZ_CITIZEN, intl: true },
];

export const australianOceanicCitizenValues = australianOceanicCitizen.map((item) => item.type);

export const otherCitizen = [
  { title: 'family.field.residency.work.visa', type: OTHER_CITIZEN_WORK_VISA, intl: true },
  { title: 'family.field.residency.travel.visa', type: OTHER_CITIZEN_TRAVEL_VISA, intl: true },
  { title: 'family.field.residency.student.visa', type: OTHER_CITIZEN_STUDENT_VISA, intl: true },
  { title: 'family.field.residency.sponsorship.visa', type: OTHER_CITIZEN_SPONSORSHIP_VISA, intl: true },
];

export const otherCitizenValues = otherCitizen.map((item) => item.type);
